<template lang="pug">
  .eui-disclaimer
      LinearProgress(v-if="loading")
      .eui-disclaimer_content
        span.eui-disclaimer_text
          span *&nbsp; {{ text }}
          span(v-if="link")
            |&nbsp;
            a(:href="link", target="_blank") {{ linkText }}
        a.live-results-link(v-if="indexLink && !isApp", :href="indexLink", target="_blank") See all live results
</template>

<script>
import LinearProgress from '../LinearProgress/LinearProgress.vue';

const body = document.querySelector('body');

export default {
  name: 'euiDisclaimer',
  props: {
    text: String,
    link: String,
    linkText: {
      type: String,
      default: 'More info'
    },
    loading: Boolean,
    embed: Boolean,
    indexLink: String
  },
  data() {
    return {
      isApp: Boolean(window.DNA_APP_ENV) || (body && body.attributes && body.attributes.length === 0) || document.querySelector('.screenkit--embed-container'),
    };
  },
  components: { LinearProgress }
};

</script>

<style lang="scss">
  @import "src/core/scss/global-sass";

  .eui-disclaimer {
    color: var(--color-fineprint);
    @include font-base-xs;
    @include thaustalianFonts();
    line-height: 1.4;
    border-top: var(--divider);
    padding: var(--spacing-unit) var(--spacing-unit);
    margin-top: var(--spacing-unit);

    &_content {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .eui-common_linear_progress {
			margin-top: calc(var(--spacing-unit) * -1);
			margin-bottom: var(--spacing-unit-x0_5);
		}

    a {
      text-decoration: underline;
    }

    a.live-results-link {
      white-space: nowrap;
    }
  }
</style>
